import { combineReducers } from 'redux';

import { FETCH_USERS_REQUEST } from 'constants/ActionTypes';

import loading from 'modules/global/reducers/generic.loading';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import { CHECK_USER_REQUEST, PATCH_DASHBOARD_SETTINGS_REQUEST, PATCH_USER } from 'modules/users/actionTypes';

import impersonate from './impersonate';
import isLoading from './isLoading';
import select from './select';
import showPasswordModal from './showPasswordModal';
import warnings from './warnings';

/**
 * @typedef {{
 *  select: import('./select').UserUiSelectReducer,
 *  dashboard: import("modules/global/reducers/simpleSearchReducer").SimpleSearchReducer,
 *  warnings: import('./warnings').WarningReducer,
 *  isLoading: boolean,
 *  impersonate: import("./impersonate").ImpersonateReducer,
 *  isPatching: boolean,
 *  isCheckingUser: boolean,
 *  customizationDrawer: boolean,
 * }} UserUiReducer
 */

export default combineReducers({
  select,
  dashboard: createSearchReducers(FETCH_USERS_REQUEST, {
    global: { matcher: ({ meta }) => meta?.source === 'dashboard' },
  }),
  warnings,
  isLoading,
  impersonate,
  showPasswordModal,
  isPatching: loading(PATCH_USER),
  isCheckingUser: loading(CHECK_USER_REQUEST),
  customizationDrawer: loading(PATCH_DASHBOARD_SETTINGS_REQUEST),
});
